var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBox1 = function SvgIconBox1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#F6F6F6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.398 4.167 3.564 17.709v14.583l10.417 6.77 10.417 6.772 10.416-6.771 10.417-6.771V17.709L24.398 4.167Z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.699 4.217 45.18 17.47 24.699 31.928 3.916 17.47 24.699 4.217Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.699 45.18V18.676M35.542 11.446v26.506",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.479 4.217 11.063 6.914-11.063 7.544-11.226-7.544L24.48 4.217Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.458 39.157V12.05",
    strokeLinecap: "round"
  }))));
};
export default SvgIconBox1;